import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './i18n';
import {
    BrowserRouter
} from 'react-router-dom';
import {AuthUserProvider} from "./context/AuthUser";

ReactDOM.render(
    <React.StrictMode>
        <AuthUserProvider>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </AuthUserProvider>
    </React.StrictMode>
    ,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
